<dropzone class="dropzone-container" [config]="config"
          [disabled]="disabled"
          fxLayout="row" fxLayoutAlign="start strech" fxFlex="auto"
          [message]="message"
          (error)="onUploadError($event)"
          (success)="onUploadSuccess($event)">
</dropzone>



// WEBPACK FOOTER //
// ./src/app/core/achoo-dropzone/achoo-dropzone.component.html